import { css } from 'styled-components'

const inputContainerStyles = css`
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 20px;
  display: flex;
  transition: 0.2s border-color ease;
  position: relative;
`

const inputStyles = css`
  width: calc(100% - 75px);
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.inputText};
  font-size: 12px;
  padding: 10px 20px;

  &::placeholder {
    color: ${({ theme }) => theme.colors.inputText};
    opacity: 0.6;
  }

  &:active,
  &:focus {
    outline: none;
  }
`

const submitIconStyles = css<{ hasText: boolean }>`
  position: absolute;
  right: 20px;
  fill: ${({ theme }) => theme.colors.icons};
  top: 0;
  bottom: 0;
  padding-top: 6px;
  width: 22px;
  cursor: ${(props) => (props.hasText ? 'pointer' : 'normal')};
`

const profaneContainerStyles = css`
  text-align: center;
  padding: 13px 0;
  border-top: 1px solid ${({ theme }) => theme.colors.error};
  position: relative;
`
const profaneHeaderStyles = css`
  ${({ theme }) => theme.fonts.bold};
  color: ${({ theme }) => theme.colors.primaryHeaderText};
  font-size: 16px;
  line-height: 26px;
  padding-bottom: 4px;
`

const profaneMessageStyles = css`
  ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 14px;
  line-height: 21px;
`

const profaneClearStyles = css`
  ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.primaryText};
  border: none;
  display: inline-block;
  cursor: pointer;
  font-size: 14px;
  line-height: 19px;
  padding-bottom: 5px;
  outline: 0;
  background: none;
  transition: 0.3s;
  text-decoration: underline;

  &:focus,
  &:hover,
  &:active {
    outline: 0;
    border: none;
  }
`

const slowModeMessageStyles = css`
  color: ${({ theme }) => theme.colors.primaryText};
  padding: 0 8px 8px 8px;
  display: flex;
  align-items: center;
  font-size: 12px;
`

export {
  profaneHeaderStyles,
  profaneMessageStyles,
  profaneClearStyles,
  profaneContainerStyles,
  inputContainerStyles,
  inputStyles,
  submitIconStyles,
  slowModeMessageStyles
}
